import React from "react";
import { Link } from "react-router-dom";
import { FeshetIcon } from "./Wordmark";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 bg-[#0F172A] text-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-4">
        {/* Brand */}
        <div className="md:col-span-1">
          <div className="flex items-center gap-3">
            <div className="p-1 rounded-xl bg-white/10">
              <FeshetIcon size={28} />
            </div>
            <span
              className="text-2xl text-white leading-none"
              style={{ fontFamily: '"DM Sans", sans-serif', fontWeight: 600, letterSpacing: "-0.025em" }}
            >
              Abonelik İptal
            </span>
          </div>
          <p className="mt-4 text-sm text-slate-400 max-w-sm leading-relaxed">
            Türkiye tüketicileri için iptal, iade ve itiraz süreçlerini
            kolaylaştıran yardımcı bir işlem asistanı.
          </p>
        </div>

        {/* Brand */}
        <div>
          <h4 className="text-xs font-bold text-white mb-4 uppercase tracking-widest">
            Abonelik İptal
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/hakkimizda" className="text-slate-300 hover:text-[#22D3CE]">Hakkımızda</Link></li>
            <li><Link to="/nasil-calisir" className="text-slate-300 hover:text-[#22D3CE]">Nasıl Çalışır?</Link></li>
            <li><Link to="/iletisim" className="text-slate-300 hover:text-[#22D3CE]">İletişim</Link></li>
            <li><Link to="/abonelik-iptali-rehberi" className="text-slate-300 hover:text-[#22D3CE]">Abonelik iptali rehberi</Link></li>
          </ul>
        </div>

        {/* Yasal */}
        <div>
          <h4 className="text-xs font-bold text-white mb-4 uppercase tracking-widest">
            Yasal
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/gizlilik-politikasi" className="text-slate-300 hover:text-[#22D3CE]">Gizlilik Politikası</Link></li>
            <li><Link to="/kvkk-aydinlatma-metni" className="text-slate-300 hover:text-[#22D3CE]">KVKK Aydınlatma Metni</Link></li>
            <li><Link to="/kullanim-sartlari" className="text-slate-300 hover:text-[#22D3CE]">Kullanım Şartları</Link></li>
            <li><Link to="/cerez-politikasi" className="text-slate-300 hover:text-[#22D3CE]">Çerez Politikası</Link></li>
          </ul>
        </div>

        {/* Popüler İşlemler */}
        <div>
          <h4 className="text-xs font-bold text-white mb-4 uppercase tracking-widest">
            Popüler İşlemler
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/netflix-uyelik-iptali" className="text-slate-300 hover:text-[#22D3CE]">Netflix üyelik iptali</Link></li>
            <li><Link to="/cayma-bedeli-itiraz-dilekcesi" className="text-slate-300 hover:text-[#22D3CE]">Cayma bedeli itiraz dilekçesi</Link></li>
            <li><Link to="/trendyol-para-iadem-yatmadi" className="text-slate-300 hover:text-[#22D3CE]">Trendyol para iadem yatmadı</Link></li>
            <li><Link to="/vodafone-net-iptal" className="text-slate-300 hover:text-[#22D3CE]">Vodafone Net iptal</Link></li>
          </ul>
        </div>
      </div>

      {/* Sybrax attribution — transparent developer credit, secondary emphasis */}
      <div className="border-t border-white/10">
        <div
          data-testid="footer-sybrax"
          className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4"
        >
          <div className="text-sm text-slate-400 leading-relaxed max-w-2xl">
            <span className="text-slate-200">
              Abonelik İptal, <span className="font-semibold">Sybrax</span> tarafından geliştirilmiştir.
            </span>
            <span className="block mt-1 text-slate-400">
              Sybrax; yapay zeka destekli web uygulamaları, SaaS ürünleri ve dijital
              platformlar geliştiren bir ürün stüdyosudur.
            </span>
          </div>
          <a
            href="https://sybrax.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-sybrax-cta"
            className="inline-flex items-center gap-1.5 self-start md:self-auto whitespace-nowrap rounded-full border border-white/15 bg-white/5 px-4 py-2 text-xs font-medium text-slate-200 hover:bg-white/10 hover:border-white/25 transition-colors"
          >
            Sybrax&apos;i keşfet
            <span aria-hidden="true">↗</span>
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-slate-400 flex flex-col md:flex-row items-start md:items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Abonelik İptal — Tüm hakları saklıdır</span>
          <span className="text-slate-500">
            Abonelik İptal resmi kurum değildir ve hukuki danışmanlık vermez.
          </span>
        </div>
      </div>
    </footer>
  );
}
